import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import messages from './appMessages';

import {Modal } from 'sa-ui';

const AppLogoutModal = props => {
    return (
        <Modal
            show={props.show}
            icon={'pe-7s-power'}
            onClose={props.onClose}
            title={props.intl.formatMessage(messages.logout)}
            message={props.intl.formatMessage(messages.confirmLogout)}
            buttons={[
                {
                label: props.intl.formatMessage(messages.cancel),
                onClick: props.onClose
                },
                {
                label: props.intl.formatMessage(messages.logout),
                onClick: props.onLogout,
                primary: true
                }
            ]}
            />
    );
};

AppLogoutModal.propTypes = {
    
};

export default injectIntl(AppLogoutModal);